var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"header-wallpaper"}),_c('img',{staticClass:"header-creator-avatar",attrs:{"src":_vm.creatorInfo.avatar}}),_c('div',{staticClass:"header-creator-info"},[_c('div',{staticClass:"creator-name"},[_vm._v(_vm._s(_vm.creatorInfo.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }